<div class="modal-summary" *ngIf="isSummary">
  <div class="loader container" *ngIf="isLoading">
    <lib-loading></lib-loading>
  </div>
  <form class="container" [formGroup]="formSummary" *ngIf="!isLoading">
    <div class="summary-form">
      <!-- HEADER -->
      <div class="title-modal">
        <div class="summary-header">
          <div>
            <p class="title">Resumo</p>
            <p class="subtitle">Confira abaixo as informações escolhidas para participar da campanha.</p>
          </div>
          <lib-loading *ngIf="btnLoading"></lib-loading>
          <lib-button-secondary
          *ngIf="!this.btnLoading && showBilletBtn()"
          id="btn-billet"
          (click)="handleBilletGeneration()">
            {{ btnBilletLabel }}
          </lib-button-secondary>
          <button 
          *ngIf="!this.btnLoading && !showBilletBtn()"
          class="btn btn-close"
          (click)="closeModal()">
            <img src="../../../assets/svgs/close_btn.svg" alt="Fechar">
          </button>
        </div>
      </div>

      <div class="summary-list">
        <p class="item"><span class="title">Produto:</span>{{ formSummary.get('productName').value }} - <a class="link" target="_blank" href="/produtos/ficha/{{formSummary.get('sku').value}}">Ficha do imóvel</a></p>
        <p class="item"><span class="title">Data da Inscrição:</span>{{ formSummary.get('subscription').value.start | date:'dd/MM/yy' }}</p>
        <p class="item"><span class="title">Status da Inscrição:</span>{{ formSummary.get('subscriptionStatusLabel').value }}</p>
        <div class="list-group">
          <div class="list-column-group">
            <p class="item"><span class="title">Mercado:</span>Primário</p>
            <p class="item"><span class="title">Início:</span>{{ formSummary.get('subscription').value.start | date:'dd/MM/yy' }}</p>
          </div>
          <div class="list-column-group">
            <p class="item"><span class="title">Investimento:</span>{{ formSummary.get('investmentAmount').value | currency: 'BRL' }}</p>
            <p class="item"><span class="title">Término:</span>{{ formSummary.get('subscription').value.end | date:'dd/MM/yy'  }}</p>
          </div>
        </div>

        <div class="list-group-mobile">
          <p class="item"><span class="title">Mercado:</span>Primário</p>
          <p class="item"><span class="title">Investimento:</span>{{ formSummary.get('investmentAmount').value | currency: 'BRL' }}</p>
          <div class="list-column-group">
            <p class="item"><span class="title">Início:</span>{{ formSummary.get('subscription').value.start | date:'dd/MM/yy' }}</p>
            <p class="item"><span class="title">Término:</span>{{ formSummary.get('subscription').value.end | date:'dd/MM/yy'  }}</p>
          </div>
        </div>
        <p class="item"
        *ngIf="isSegmentationAvailable">
          <span class="title">Tipo de segmentação:</span>
          {{ formSummary.get('typeSegmentation').value }}
        </p>
      </div>

      <div class="participants">
        <ul class="participants-list">
          <li class="items" *ngFor="let user of participants.controls; let i = index">
            <app-participants-card 
            [index]="i" 
            [user]="user.value"
            [campaignId]="campaign.id"
            [participants]="participants"
            (removeParticipant)="removeParticipant($event)"
            (editParticipant)="editParticipant($event)"
            [editable]="isEditable">
          </app-participants-card>
          </li>
        </ul>

        <div class="add-participants"
        [ngClass]="{
          invisible: participants.length >= maxParticipants || !isEditable
        }">
          <lib-button-secondary 
          (onclick)="newParticipant()"
          [isDisabled]="participants.length >= maxParticipants || !isEditable">
            Adicionar corretor
          </lib-button-secondary>
          <p>Máximo: {{ maxParticipants }} participantes</p>
        </div>
      </div>

    </div>
    <div class="footer-modal">
      <lib-button-tertiary class="btn"
      (click)="closeModal()">
        Voltar
      </lib-button-tertiary>
      <lib-button-primary class="btn"
      [isDisabled]="isFormInvalid() || !isEditable"
      (click)="save()">
        Confirmar alteração
      </lib-button-primary>
    </div>
  </form>
</div>